var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.oferta)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"small":"","icon":"","link":"","target":"_blank","to":_vm.link}},on),[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)]}}],null,false,893665580)},[_c('span',[_vm._v(" Abrir oferta ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }